import axios from 'axios'
import CONFIG from '../config'
import { Toast } from 'vant'
// import qs from 'qs'
// import store from '../store'
// import { cloneDeep } from 'lodash'


// localStorage.setItem('access_token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1OTc3MzM1OTEsIm5iZiI6MTU5NzczMzU5MSwianRpIjoiOWViNmEwYTktYzc4Mi00YTM4LWFiZmUtNTlmNWM2ZmE5MGM3IiwiZXhwIjoxNjAwMzI1NTkxLCJpZGVudGl0eSI6ImZkYzcyZTBlLTgwNGMtNGI1MC05ODU2LTUyZGM5ZGM3ZWU2MSIsImZyZXNoIjpmYWxzZSwidHlwZSI6ImFjY2VzcyJ9.JrSszzTThdiSYKWoIJCO6D_C0W_U3a6j3Q_VHiEYYcw')

function getCurrentZoneTime() {
  const offset = new Date().getTimezoneOffset()
  const current = Math.abs(offset * 60)
  return current
}

// function toast(msg) {
//   Toast({
//     message: msg,
//     align: "center",
//     duration: 3000, //消失时间
//     className: 'toast-trans'
//   })
// }

const config = {
  baseURL: CONFIG.baseURL,
  timeout: 5 * 1000,  // 请求超时时间
  headers: {
    'content-type': 'application/json'
  },
  validatorStatus(status) {
    return status >= 200 && status < 510
  },
  transformRequest: [(data) => {
    data = JSON.stringify(data)       // 序列化
    return data     // return 必须是一个字符串，或 ArrayBuffer，或 Stream 
  }]
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  originConfig => {
    const access_token = localStorage.getItem('access_token')
    const Authorization = `Bearer ${access_token}`
    const reqConfig = { ...originConfig }
    reqConfig.headers.Authorization = Authorization
    reqConfig.headers['time-zone-offset-seconds'] = getCurrentZoneTime()
    return reqConfig
  }
)

_axios.interceptors.response.use(
  res => {
    if(res.status.toString().startsWith('2') && res.data.state_code === 0) {
      return res.data
    }
    const { error_msg } = res
    Toast({message: error_msg || res.data.error_msg,className: 'toast-trans'})
  },

  error => {
    if (!error.response) {
      Toast({message:'请检查 API 是否异常', className: 'toast-trans'})
    }

    //  判断请求超时
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      Toast({message: '请求超时', className:'toast-trans'})
    }

    return Promise.reject(error)
  }
)

// 导出常用函数

/**
 * @param {string} url
 * @param {object} data
 * @param {object} params
 */

export function post(url, data = {}, params = {}) {
  return _axios({
    method: 'POST',
    url,
    data,
    params
  })
}

/**
* 
* @param {string} url 
* @param {object} params 
*/
export function get(url, params = {}) {
  return _axios({
    method: 'GET',
    url,
    params
  })
}
